import axios from "axios";
import config from "../config";
import { enqueueSnackbar } from "notistack";
import { eraseGlobalCookie } from '../utils';
import { getGlobalCookie } from './index';
import { isNetworkError, reportNetworkFailure } from './networkStatus';
require("es6-promise").polyfill();

// Axios instance for networkInterface
const apiInstannce = axios.create({
  baseURL: config.api.networkInterface
});

// Axios instance for console API
const consoleAxiosInstance = axios.create({
  baseURL: config.api.commonApi
});

const aiApiInstance = axios.create({
  baseURL: config.api.aiChatUrl
});

// Axios instance for console API
const notificationAxiosInstance=axios.create({
  baseURL:config.api.notification
})

// Add a request interceptor for apiInstannce
aiApiInstance.interceptors.request.use(
  function (config) {
    let lessorAccess = JSON.parse(getGlobalCookie('lessorAccess'));
    if (lessorAccess) {
      config['headers']['Authorization'] = lessorAccess?.access;
    }

    // Do something before request is sent

    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

// Add a response interceptor for AxiosInstance
aiApiInstance.interceptors.response.use(
  function (response) {
    if (response?.data?.statusCode === 1001) {
      enqueueSnackbar('Your previous logged in session expired, please login again', { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" }});
      eraseGlobalCookie('lessorAccess');
      window.location.href = `${config.domain.subDomian}login?apps=leaseRevamp`;
    }
    return response;
  },
  function (error) {
    return Promise.reject(error);
  }
);

// Add a request interceptor for apiInstannce
notificationAxiosInstance.interceptors.request.use(
  function (config) {
    let lessorAccess = JSON.parse(getGlobalCookie('lessorAccess'));
    if (lessorAccess) {
      config['headers']['Authorization'] = lessorAccess?.access;
    }

    // Do something before request is sent

    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

// Add a request interceptor for apiInstannce
apiInstannce.interceptors.request.use(
  function (config) {
    let lessorAccess = JSON.parse(getGlobalCookie('lessorAccess'));
    if (lessorAccess) {
      config['headers']['Authorization'] = lessorAccess?.access;
    }

    // Do something before request is sent

    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

// Add a response interceptor for AxiosInstance
apiInstannce.interceptors.response.use(
  function (response) {
    if (response?.data?.statusCode === 1001) {
      enqueueSnackbar('Your previous logged in session expired, please login again', { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" }});
      eraseGlobalCookie('lessorAccess');
      window.location.href = `${config.domain.subDomian}login?apps=leaseRevamp`;
    }
    return response;
  },
  function (error) {
    return Promise.reject(error);
  }
);

apiInstannce.interceptors.response.use(
  response => response,
  error => {
    if (
      error?.response?.status === 502 ||
      error?.message === "Network Error"
    ) {
      return Promise.reject({
        ...error,
        customMessage:
          "Service temporarily unavailable. Please try again."
      });
    }
    return Promise.reject(error);
  }
);

// Release stuck loaders on network failures, for every instance
[apiInstannce, consoleAxiosInstance, aiApiInstance, notificationAxiosInstance].forEach(instance => {
  instance.interceptors.response.use(
    response => response,
    error => {
      if (isNetworkError(error)) reportNetworkFailure();
      return Promise.reject(error);
    }
  );
});


// Export both instances
export { consoleAxiosInstance,notificationAxiosInstance, aiApiInstance};
export default apiInstannce;